import { createSlice } from '@reduxjs/toolkit'
import {
  applicationViewBase,
  applicationViewCustfields,
  destroyApplicationViewBase,
  destroyApplicationViewCustFields,
} from './application-view.actions'
import { combineReducers } from 'redux'

type InitialState = {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  data: unknown
  error: string | null
}

const initialState: InitialState = {
  status: 'idle',
  data: null,
  error: null,
}

export const ApplicationViewBaseSlice = createSlice({
  name: 'application_view_base',
  initialState,
  reducers: {},
  extraReducers: {
    [applicationViewBase.pending.toString()]: (state) => {
      state.status = 'loading'
      state.error = null
    },
    [applicationViewBase.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
      state.error = null
    },
    [applicationViewBase.pending.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
    [destroyApplicationViewBase.toString()]: () => {
      return initialState
    },
  },
})

export const ApplicationCustFieldsSlice = createSlice({
  name: 'application_view_custfields',
  initialState,
  reducers: {},
  extraReducers: {
    [applicationViewCustfields.pending.toString()]: (state) => {
      state.status = 'loading'
      state.error = null
    },
    [applicationViewCustfields.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
      state.error = null
    },
    [applicationViewCustfields.pending.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
    [destroyApplicationViewCustFields.toString()]: (state, action) => {
      return initialState
    },
  },
})

export const applicationViewReducer = combineReducers({
  base: ApplicationViewBaseSlice.reducer,
  custFields: ApplicationCustFieldsSlice.reducer,
})
